export enum PageTitles {
  EMPTY = '',
  FAQ = 'Perguntas frequentes',
  REGISTRATION_FORM = 'Ficha de cadastro',
  REDEEM_VALUE = 'Resgatar saldo',
}
